import { useState, useEffect } from 'react';
import apiClient from '../utils/apiClient';

const useWardenPermissions = () => {
  const [permissions, setPermissions] = useState({
    can_update_attendance: false,
    can_update_health: false,
    can_update_activities: false,
    can_update_results: false,
    can_update_student_details: false,
    can_update_parent_contact: false,
    can_send_notifications: false,
    can_manage_gallery: false
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPermissions();
  }, []);

  const fetchPermissions = async () => {
    try {
      const user = JSON.parse(localStorage.getItem('hostelconnect_user') || '{}');
      
      // Only fetch if user is a warden
      if (user.role !== 'warden') {
        setLoading(false);
        return;
      }

      const response = await apiClient.get('/v1/warden/permissions/my-permissions');
      setPermissions(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching warden permissions:', error);
      setLoading(false);
    }
  };

  const hasPermission = (permission) => {
    return permissions[permission] || false;
  };

  return {
    permissions,
    loading,
    hasPermission,
    refreshPermissions: fetchPermissions
  };
};

export default useWardenPermissions;
